import CreateNewDocCard from "./CreateNewDocCard";

export default CreateNewDocCard;
